<ng-container *ngIf="showInvoiceDetails">
	<ng-template #invoiceDetails let-modal>
		<div class="modal-header" *ngIf="displaydetails">
			<h4 class="modal-title" id="modal-title">{{ displaydetails.title }}</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		</div>
		<div class="modal-body">
			<div class="mb-3" *ngIf="displaydetails">
				<h4></h4>
				<ng-container *ngIf="displaydetails.type == 'html'">
					<div [innerHTML]="displaydetails.display">
					</div>
				</ng-container>
				<ng-container *ngIf="displaydetails.type == 'pdf'">
					<ngx-extended-pdf-viewer [base64Src]="displaydetails.display" useBrowserLocale="true" [handTool]="false" [textLayer]="true" [showOpenFileButton]="false" [showPropertiesButton]="false" [showHandToolButton]="true" [filenameForDownload]="displaydetails.title"></ngx-extended-pdf-viewer>
				</ng-container>
			</div>
		</div>
		<div class="modal-footer">
		</div>
	</ng-template>
</ng-container>
<ng-container *ngIf="showOrderDetails">
	<ng-template #orderDetails let-modal>
		<div class="modal-header" *ngIf="orderdetails">
			<div class="modal-title row m-0 p-0" id="modal-title">
				<h4>Order# {{orderdetails.header.orderno}}</h4>
				<span *ngIf="orderdetails.header.tpl3pl_remote_order_id" class="ml-2 text-muted small align-middle">3PL ID: {{ orderdetails.header.tpl3pl_remote_order_id }}</span>
			</div>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		</div>
		<div class="modal-body" *ngIf="orderdetails">
			<div class="mb-3" *ngIf="orderdetails">
				<div class="" *ngIf="orderdetails.dispatch_details && orderdetails.dispatch_details.status_id == '29'">

					<div #mapDiv class="w-100" [ngClass]="{'d-none': !orderdetails.dispatch_details.nextlast}">
						EST: {{orderdetails.dispatch_details.nextlast }}
						<div class="w-100" id="map">
						</div>
					</div>
				</div>

				<div class="row border-bottom" *ngIf="orderdetails.header.debtorno">
					<div class="col-12">
						<h5 class="mb-0">Customer:</h5>
						<mat-divider></mat-divider>
						<a [routerLink]="['/customers/view', orderdetails.header.debtorno]" (click)="modal.dismiss('Customer link')">{{ orderdetails.header.debtorno }}{{ orderdetails.header.branchcode ? '.' + orderdetails.header.branchcode : '' }}</a>
						<span *ngIf="orderdetails.header.name"> — {{ orderdetails.header.name }}</span>
					</div>
				</div>
				<div class="row border-bottom">
					<div class="col-md-3 text-center">
						<h5>Ship Via: {{ orderdetails.header.shippername }}</h5>
					</div>
					<div class="col-md-3 text-center">
						<h5>Date Wanted: {{ orderdetails.header.datewanted }}</h5>
					</div>
					<div class="col-md-3 text-center">
						<h5>Entered By: {{ orderdetails.header.enteredby }}</h5>
					</div>
					<div class="col-md-3 text-center">
						<h5>Created: {{ orderdetails.header.date_created }}</h5>
					</div>
				</div>
				<div class="row mt-2 mb-2 border-bottom">
					<div class="col-md-3 ">
						<h5 class="mb-0">Ship To:</h5>
						<mat-divider></mat-divider>
						<span class="mt-2" [innerHTML]="orderdetails.header.shipto"></span>
					</div>
					<div class="col-md-3">
						<h5 class="mb-0">Phone:</h5>
						<mat-divider></mat-divider>
						<span class="mt-2">{{orderdetails.header.contactphone}}</span>

						<ng-container *ngIf="orderdetails.header.contactemail && orderdetails.header.contactemail != ''">
							<h5 class="mb-0 mt-2">Email:</h5>
							<mat-divider></mat-divider>
							<span class="mt-2">{{orderdetails.header.contactemail}}</span>
						</ng-container>
					</div>
					<div class="col-md-3">
						<h5 class="mb-0">Notes:</h5>
						<mat-divider></mat-divider>
						<span class="mt-2">{{orderdetails.header.comments}}</span>
					</div>
					<div class="col-md-3">
						<h5 class="mb-0">History: </h5>
						<mat-divider></mat-divider>
						<ng-container *ngIf="orderdetails.dispatch_details.dispatch_id">
							<ul class="mt-2">
								<li *ngIf="orderdetails.dispatch_details.truck_name">
									ShipVia: {{ orderdetails.dispatch_details.truck_name }}<br>
									{{ orderdetails.dispatch_details.driveruserid }}
								</li>
								<li *ngIf="orderdetails.dispatch_details.datecreated !='0000-00-00 00:00:00'">Dispatched:
									{{ orderdetails.dispatch_details.datecreated | date:'shortDate' }}
									{{ orderdetails.dispatch_details.datecreated | date:'shortTime' }}

								</li>
								<li *ngIf="orderdetails.dispatch_details.delivery_date !='0000-00-00 00:00:00'">Delivered:
									{{ orderdetails.dispatch_details.delivery_date | date:'shortDate' }}
									{{ orderdetails.dispatch_details.delivery_date | date:'shortTime' }}
								</li>
							</ul>
						</ng-container>
						<ng-container *ngIf="!orderdetails.dispatch_details.dispatch_id">
							N/A
						</ng-container>
					</div>
				</div>
				<div class="table">
					<table class="table table-sm fs-bigger">
						<tr>
							<th>ITEM</th>
							<th>DESC</th>
							<th class="text-center">QOH</th>
							<th class="text-center">ORDERED</th>
							<th class="text-center">INVOICED</th>
							<th class="text-center">OUTSTANDING</th>
							<th class="text-right">PRICE</th>
							<th class="text-right" *ngIf="config.discounts">DISCOUNT</th>
							<th class="text-right">TOTAL</th>
						</tr>
						<tr *ngFor="let item of orderdetails.details">

							<td>{{item.stkcode}}</td>
							<td>{{item.description}}</td>
							<td class="text-center">{{item.qoh}}</td>
							<td class="text-center">{{item.ordered}}</td>
							<td class="text-center">{{item.qtyinvoiced}}</td>
							<td class="text-center">{{item.ordered - item.qtyinvoiced}}</td>
							<td class="text-right">{{item.unitprice | currency}}</td>
							<td class="text-right" *ngIf="config.discounts">{{item.discountpercent | percent }}</td>
							<td class="text-right">{{item.discountprice * item.ordered | currency}}</td>
						</tr>
						<tr *ngFor="let t of orderdetails.saved_totals">
							<td></td>
							<td></td>
							<td></td>
							<td class="text-center"></td>
							<td class="text-center"></td>
							<td class="text-center"></td>
							<td class="text-center" *ngIf="config.discounts"></td>
							<td class="text-right">{{ t.title }}:</td>
							<td class="text-right">{{t.text | currency}}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div class="modal-footer">
		</div>
	</ng-template>
</ng-container>
<div class="recent-transactions">
	<div class="recent-transactions__wrapper">
		<div class="recent-transactions__header">
			<div class="recent-transactions__title">
				<span class="recent-transactions__icon"><i class="material-icons">receipt_long</i></span>
				<div class="recent-transactions__title-text">
					<h4>Recent Transactions</h4>
					<span class="recent-transactions__subtitle">{{ calculateDaysBetween(datefrom.value, dateto.value) || '—' }}</span>
				</div>
			</div>

			<div class="recent-transactions__header-actions">
				<span class="recent-transactions__result-count" *ngIf="mergedResults?.length !== undefined">
					<i class="material-icons">list_alt</i>{{ mergedResults.length | number:'1.0-0' }}
				</span>
				<button mat-icon-button class="donotprint" (click)="exportXls()"
					[disabled]="running || !mergedResults?.length"
					matTooltip="Export every row in range to Excel" matTooltipPosition="above"
					aria-label="Export to Excel">
					<mat-icon>grid_on</mat-icon>
				</button>
				<button mat-icon-button class="donotprint" (click)="exportPdf()"
					[disabled]="running || !mergedResults?.length"
					matTooltip="Export every row in range to PDF" matTooltipPosition="above"
					aria-label="Export to PDF">
					<mat-icon>picture_as_pdf</mat-icon>
				</button>
				<div *ngIf="running" class="recent-transactions__spinner">
					<svg class="spinner" width="22" height="22" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
			</div>
		</div>

		<div class="recent-transactions__filters">
			<mat-form-field appearance="outline" class="recent-transactions__filter recent-transactions__filter--range">
				<mat-label>Date Range</mat-label>
				<mat-date-range-input [rangePicker]="rangePicker">
					<input matStartDate placeholder="Date From" [formControl]="datefrom">
					<input matEndDate placeholder="Date To" [formControl]="dateto">
				</mat-date-range-input>
				<mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
				<mat-date-range-picker #rangePicker></mat-date-range-picker>
				<mat-error *ngIf="isInvalidDateRange()">Both dates must be selected</mat-error>
			</mat-form-field>

			<mat-form-field appearance="outline" class="recent-transactions__filter recent-transactions__filter--type">
				<mat-label>Type</mat-label>
				<mat-select [formControl]="sortby" (selectionChange)="sortData()">
					<mat-option *ngFor="let stat of sortOptions" [value]="stat.value">
						{{ stat.view }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="recent-transactions__filter recent-transactions__filter--search">
				<mat-label>Search</mat-label>
				<input matInput placeholder="Order #, Customer, Transaction #" [formControl]="searchInput" (keyup.enter)="search()" />
				<button mat-icon-button matSuffix (click)="search()" aria-label="Search">
					<mat-icon>search</mat-icon>
				</button>
			</mat-form-field>
		</div>

		<div class="recent-transactions__body">
			<div class="table-container table-container--desktop mt-0 w-100">

				<table mat-table [dataSource]="dataSource" matSort class="table-fixed">

					<!-- Action Column -->
					<ng-container matColumnDef="actions">
						<th mat-header-cell *matHeaderCellDef class="text-left"> </th>
						<td mat-cell *matCellDef="let item" class="text-left">
							<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More" class="donotprint">
								<mat-icon>more_vert</mat-icon>
							</button>
							<mat-menu #menu="matMenu">
								<ng-container *ngIf="item.orderno">
									<button mat-menu-item (click)="viewOrder(item.orderno)">
										<mat-icon>visibility</mat-icon>
										<span>View HTML</span>
									</button>
									<a href="{{invoicelink}}{{item.orderno}}" mat-menu-item>
										<mat-icon>print</mat-icon>
										<span>Customer Copy</span>
									</a>
								</ng-container>
								<ng-container *ngIf="item.transno">
									<button mat-menu-item (click)="openDocument(item, 'html')" *ngIf="item.transno">
										<mat-icon>visibility</mat-icon>
										<span>View HTML</span>
									</button>
									<button mat-menu-item (click)="openDocument(item, 'pdf')">
										<mat-icon>visibility</mat-icon>
										<span>View PDF</span>
									</button>
								</ng-container>
							</mat-menu>


						</td>
					</ng-container>

					<!-- Order # Column -->
					<ng-container matColumnDef="orderno">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Order #</th>
						<td mat-cell *matCellDef="let item" class="text-left">
							{{ item.orderno || item.order_ }}
							<ng-container *ngIf="channelSourceLabel(item) as chSrc">
								<span class="order-channel-badge"
									[ngClass]="chSrc === 'Distru' ? 'order-channel-badge--distru' : 'order-channel-badge--leaflink'">{{ chSrc }}</span>
							</ng-container>
						</td>
					</ng-container>

					<!-- Order Date Column -->
					<ng-container matColumnDef="trandate">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Order Date</th>
						<td mat-cell *matCellDef="let item" class="text-left">{{ item.trandate || item.deliverydate }}</td>
					</ng-container>

					<!-- Order Status Column -->
					<ng-container matColumnDef="typename">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Status</th>
						<td mat-cell *matCellDef="let item" class="text-left">
							<ng-container *ngIf="getStatusStyle(item) as st">
								<span class="status-pill" [style.background-color]="st.bg" [style.color]="st.fg">
									<span class="status-pill__dot" [style.background-color]="st.fg"></span>
									{{ st.label }}
								</span>
							</ng-container>
						</td>

					</ng-container>

					<!-- Customer Column -->
					<ng-container matColumnDef="customer">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Customer</th>
						<td mat-cell *matCellDef="let item" class="text-left">
							<a [routerLink]="['/customers/view', item.debtorno]">
								({{ item.debtorno }}.{{ item.branchcode }})</a> {{ item.name || item.deliverto }}

						</td>
					</ng-container>

					<!-- Amount Column -->
					<ng-container matColumnDef="ovamount">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Amount</th>
						<td mat-cell *matCellDef="let item" class="text-left">{{ (item.ovamount ?? 0) | currency }}</td>
					</ng-container>

					<!-- Tax Column -->
					<ng-container matColumnDef="ovgst">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Tax</th>
						<td mat-cell *matCellDef="let item" class="text-left">{{ (item.ovgst ?? 0) | currency }}</td>
					</ng-container>

					<!-- Freight Column -->
					<ng-container matColumnDef="ovfreight">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Freight</th>
						<td mat-cell *matCellDef="let item" class="text-left">{{ (item.ovfreight ?? 0) | currency }}</td>
					</ng-container>

					<!-- Total Column -->
					<ng-container matColumnDef="total">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Total</th>
						<td mat-cell *matCellDef="let item" class="text-left">{{ item.total | currency }}</td>
					</ng-container>

				<ng-container matColumnDef="tracking">
						<th mat-header-cell *matHeaderCellDef class="text-left">Tracking</th>
						<td mat-cell *matCellDef="let item" class="text-left tracking-cell">
							<ng-container *ngIf="item.tracking && item.tracking.length > 0; else noTracking">
								<div *ngFor="let t of item.tracking" class="tracking-entry">
									<span class="tracking-carrier" *ngIf="t.shippername">{{ t.shippername }}: </span>
									<ng-container *ngIf="(t.trackingnumber | trackingUrl:t.shippername:t.url) as trackHref; else ooiPlainTrack">
										<a [href]="trackHref"
											target="_blank"
											rel="noopener noreferrer"
											class="tracking-number tracking-number--link"
											[matTooltip]="'Track ' + (t.shippername || 'shipment') + ' — opens in new tab'"
											matTooltipPosition="above">
											{{ t.trackingnumber }}<i class="material-icons tracking-link-icon">open_in_new</i>
										</a>
									</ng-container>
									<ng-template #ooiPlainTrack>
										<span class="tracking-number">{{ t.trackingnumber }}</span>
									</ng-template>
								</div>
							</ng-container>
							<ng-template #noTracking>
								<span class="text-muted">—</span>
							</ng-template>
						</td>
					</ng-container>

				<ng-container matColumnDef="printedpackingslip">
						<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Printed</th>
						<td mat-cell *matCellDef="let item" [ngClass]="{'text-danger': item.printedpackingslip != '1', 'text-success': item.printedpackingslip == '1'}" class="text-left">
							{{ item.printedpackingslip == '1' ? 'Y' : 'N' }}
						</td>
					</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
				</table>
			</div>

			<ul class="recent-transactions__mobile-list">
				<ng-container *ngIf="(dataObs | async) as rows">
					<li class="rt-card" *ngFor="let item of rows">
						<div class="rt-card__top">
							<div class="rt-card__ids">
								<span class="rt-card__orderno">#{{ item.orderno || item.order_ || item.transno }}</span>
								<span class="rt-card__date">{{ item.trandate || item.deliverydate }}</span>
							</div>
							<ng-container *ngIf="getStatusStyle(item) as st">
								<span class="status-pill rt-card__status" [style.background-color]="st.bg" [style.color]="st.fg">
									<span class="status-pill__dot" [style.background-color]="st.fg"></span>
									{{ st.label }}
								</span>
							</ng-container>
						</div>

						<div class="rt-card__customer">
							<a [routerLink]="['/customers/view', item.debtorno]" class="rt-card__customer-id">
								{{ item.debtorno }}<ng-container *ngIf="item.branchcode">.{{ item.branchcode }}</ng-container>
							</a>
							<span class="rt-card__customer-name">{{ item.name || item.deliverto }}</span>
						</div>

						<div class="rt-card__amounts">
							<div class="rt-card__amount-group">
								<span class="rt-card__amount-label">Amount</span>
								<span class="rt-card__amount-value">{{ (item.ovamount ?? 0) | currency }}</span>
							</div>
							<div class="rt-card__amount-group">
								<span class="rt-card__amount-label">Tax</span>
								<span class="rt-card__amount-value">{{ (item.ovgst ?? 0) | currency }}</span>
							</div>
							<div class="rt-card__amount-group">
								<span class="rt-card__amount-label">Freight</span>
								<span class="rt-card__amount-value">{{ (item.ovfreight ?? 0) | currency }}</span>
							</div>
							<div class="rt-card__amount-group rt-card__amount-group--total">
								<span class="rt-card__amount-label">Total</span>
								<span class="rt-card__amount-value">{{ item.total | currency }}</span>
							</div>
						</div>

						<div class="rt-card__meta" *ngIf="(item.tracking && item.tracking.length) || item.printedpackingslip !== undefined">
							<ng-container *ngIf="item.tracking && item.tracking.length">
								<div class="rt-card__meta-item rt-card__meta-item--tracking">
									<i class="material-icons">local_shipping</i>
									<div class="rt-card__tracking-list">
										<div *ngFor="let t of item.tracking" class="tracking-entry">
											<span class="tracking-carrier" *ngIf="t.shippername">{{ t.shippername }}: </span>
											<ng-container *ngIf="(t.trackingnumber | trackingUrl:t.shippername:t.url) as trackHrefM; else ooiPlainTrackMobile">
												<a [href]="trackHrefM"
													target="_blank"
													rel="noopener noreferrer"
													class="tracking-number tracking-number--link"
													[matTooltip]="'Track ' + (t.shippername || 'shipment') + ' — opens in new tab'"
													matTooltipPosition="above">
													{{ t.trackingnumber }}<i class="material-icons tracking-link-icon">open_in_new</i>
												</a>
											</ng-container>
											<ng-template #ooiPlainTrackMobile>
												<span class="tracking-number">{{ t.trackingnumber }}</span>
											</ng-template>
										</div>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="item.printedpackingslip !== undefined">
								<span class="rt-card__meta-item rt-card__packingslip" [ngClass]="{'is-yes': item.printedpackingslip == '1', 'is-no': item.printedpackingslip != '1'}">
									<i class="material-icons">{{ item.printedpackingslip == '1' ? 'check_circle' : 'radio_button_unchecked' }}</i>
									<span>Packing Slip</span>
								</span>
							</ng-container>
						</div>

						<div class="rt-card__actions">
							<ng-container *ngIf="item.orderno">
								<button mat-stroked-button (click)="viewOrder(item.orderno)">
									<mat-icon>visibility</mat-icon> View
								</button>
								<a href="{{invoicelink}}{{item.orderno}}" mat-stroked-button>
									<mat-icon>print</mat-icon> Copy
								</a>
							</ng-container>
							<ng-container *ngIf="item.transno">
								<button mat-stroked-button (click)="openDocument(item, 'html')">
									<mat-icon>visibility</mat-icon> HTML
								</button>
								<button mat-stroked-button (click)="openDocument(item, 'pdf')">
									<mat-icon>picture_as_pdf</mat-icon> PDF
								</button>
							</ng-container>
						</div>
					</li>
					<li class="rt-card rt-card--empty" *ngIf="!rows || rows.length === 0">
						<span class="text-muted">No transactions.</span>
					</li>
				</ng-container>
			</ul>

			<div class="recent-transactions__totals">
				<span class="recent-transactions__totals-label">TOTALS</span>
				<span class="recent-transactions__totals-chip">
					<span class="recent-transactions__totals-chip-label">Amount</span>
					<span class="recent-transactions__totals-chip-value">{{ total_sub | currency }}</span>
				</span>
				<span class="recent-transactions__totals-chip">
					<span class="recent-transactions__totals-chip-label">Tax</span>
					<span class="recent-transactions__totals-chip-value">{{ total_tax | currency }}</span>
				</span>
				<span class="recent-transactions__totals-chip">
					<span class="recent-transactions__totals-chip-label">Freight</span>
					<span class="recent-transactions__totals-chip-value">{{ total_freight | currency }}</span>
				</span>
				<span class="recent-transactions__totals-chip recent-transactions__totals-chip--emphasis">
					<span class="recent-transactions__totals-chip-label">Total</span>
					<span class="recent-transactions__totals-chip-value">{{ total_trans | currency }}</span>
				</span>
			</div>

			<mat-paginator #paginator [pageSizeOptions]="[10, 25, 50, 100, 500]" showFirstLastButtons aria-label="select page">
			</mat-paginator>
		</div>
	</div>
</div>